/**
 * Design System - Spacing Tokens
 * Sistema di spaziatura basato su multipli di 4px
 */

export const spacing = {
  // Base spacing unit (4px)
  unit: 4,

  // Spacing scale (in px)
  xs: 4,    // 4px
  sm: 8,    // 8px
  md: 16,   // 16px
  lg: 24,   // 24px
  xl: 32,   // 32px
  '2xl': 48, // 48px
  '3xl': 64, // 64px
  '4xl': 96, // 96px
  '5xl': 128, // 128px

  // Custom spacing
  section: 32,    // Spacing between sections
  component: 16,  // Spacing between components
  element: 8,     // Spacing between elements
  text: 4,        // Spacing between text elements
};

// Material-UI spacing function
export const createSpacing = (unit: number = spacing.unit) => {
  return (factor: number) => `${factor * unit}px`;
};

// Predefined spacing values for common use cases
export const spacingValues = {
  // Padding
  padding: {
    xs: `${spacing.xs}px`,
    sm: `${spacing.sm}px`,
    md: `${spacing.md}px`,
    lg: `${spacing.lg}px`,
    xl: `${spacing.xl}px`,
  },

  // Margin
  margin: {
    xs: `${spacing.xs}px`,
    sm: `${spacing.sm}px`,
    md: `${spacing.md}px`,
    lg: `${spacing.lg}px`,
    xl: `${spacing.xl}px`,
  },

  // Gap (for flexbox/grid)
  gap: {
    xs: `${spacing.xs}px`,
    sm: `${spacing.sm}px`,
    md: `${spacing.md}px`,
    lg: `${spacing.lg}px`,
    xl: `${spacing.xl}px`,
  },

  // Border radius
  borderRadius: {
    xs: `${spacing.xs / 2}px`, // 2px
    sm: `${spacing.sm / 2}px`, // 4px
    md: `${spacing.md / 2}px`, // 8px
    lg: `${spacing.lg / 2}px`, // 12px
    xl: `${spacing.xl / 2}px`, // 16px
    full: '50%',
  },
};
